export enum InsuranceProvider {
  AXA = 'AXA',
  HELVETIA = 'HELVETIA',
  MMA = 'MMA',
  GUEMAS = 'GUEMAS',
  CARAVELLE = 'CARAVELLE',
  TOKIO_MARINE_HCC = 'TOKIO_MARINE_HCC',
  ALLIANZ_TRANSPORT_PRIVE = 'ALLIANZ_TRANSPORT_PRIVE',
  ALLIANZ_ASSURFRET = 'ALLIANZ_ASSURFRET',
  MS_AMLIN = 'MS_AMLIN',
  GENERALI = 'GENERALI',
}

export const INSURANCE_PROVIDER_OPTIONS = Object.values(InsuranceProvider).map(provider => ({
  value: provider,
  label: provider,
}));
